export const CAN_SERVICE_GESTURE_FEATURE_FLAG = 'can_service_gesture';
export const LENS_REPLACEMENT_FOR_READERS_FEATURE_FLAG = 'shop_app_lens_replacement_for_readers';
